import { createSlice } from '@reduxjs/toolkit'

export const infoSlice = createSlice({
  name: 'info',
  initialState: {
    role: '',
    location: null,
    frequency: null,
  },
  reducers: {
    setRole: (state, action) => {
      state.role = action.payload
    },
    setLocation: (state, action) => {
      state.location = action.payload;
    },
    setFrequency: (state, action) => {
      state.frequency = action.payload;
    },
  },
})

export const { setRole, setLocation, setFrequency } = infoSlice.actions

export const selectRole = (state) => state.info.role
export const selectLocation = (state) => state.info.location
export const selectFrequency = (state) => state.info.frequency


export default infoSlice.reducer
